import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BONOS } from './salesData';
export function BonosSection() {
  return <section id="bonos" className="bg-sand py-12 sm:py-16" data-id="element-56" data-mp="13d4fiklb3xpu">
      <div className="mx-auto max-w-5xl px-5" data-id="element-57" data-mp="13bkz8tznhmo2">
        <div className="text-center" data-id="element-58" data-mp="ydru84a32ypd">
          <SectionTag data-id="element-59" data-mp="ycqidxl8u86l">Incluido sin costo</SectionTag>
          <h2 className="mt-4 font-display text-[1.5rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.2rem]" data-id="element-60" data-mp="tg00d4pvp2ij">
            Y además te llevás
            <span className="mt-1 block text-gold-deep" data-id="element-61" data-mp="oizuatt13zrf">5 bonos de regalo</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-62" data-mp="kh6094dc9u08">
            Recursos complementarios que se entregan junto con el Mega Pack para que puedas aplicar
            el sistema más rápido, sin costo adicional.
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-id="element-63" data-mp="29s5devtw6pz2">
          {BONOS.map((bono, i) => <motion.li key={bono.num} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex h-full flex-col overflow-hidden rounded-2xl border border-stone bg-ivory" data-id="element-64" data-mp="vu97dhanwv2y" data-mpi={i}>
              <div className="relative flex items-center justify-center border-b border-stone bg-charcoal" style={{
            aspectRatio: '3 / 4'
          }} data-id="element-65" data-mp="1ekz7wzcrg5sn">
                {bono.cover ? <img src={bono.cover} alt={`Portada de ${bono.label}`} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-66" data-mp="15s5bvq93grs3" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-ivory/10" data-id="element-67" data-mp="284oomarkuvj9">
                    <GiftIcon className="h-5 w-5 text-gold" aria-hidden data-id="element-68" data-mp="235c1rq0phogo" />
                  </span>}
                <span className="absolute left-2 top-2 rounded-full bg-gold px-2 py-0.5 font-sans text-[0.55rem] font-bold uppercase tracking-[0.12em] text-ivory" data-id="element-69" data-mp="1y5zfb6dqyjem">
                  Gratis
                </span>
              </div>

              <div className="px-3 py-3" data-id="element-70" data-mp="1p7nj8ou42tes">
                <p className="font-sans text-[0.55rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-71" data-mp="1kfnmt6d92imy">
                  Bono {Number(bono.num)}
                </p>
                <h3 className="mt-1 font-display text-[0.9rem] font-bold uppercase leading-tight text-charcoal" data-id="element-72" data-mp="1fe6onim5haa2">
                  {bono.label}
                </h3>
              </div>
            </motion.li>)}
        </ul>

        <p className="mt-5 text-center font-sans text-[0.85rem] font-medium text-charcoal/75" data-id="element-73" data-mp="11fzw8hzz02hs">
          Los 5 bonos se entregan junto con los 6 tomos, en el mismo acceso y en el mismo pago.
        </p>
      </div>
    </section>;
}